const info = {
  ZH: {
    //中文翻译
    CHONG: "充值",
    code: "客户代码",
    coupon: "优惠券",
    DQtime: "到期时间",
    yue: "月",
    zhe: "折",
    vip: "会员",
    dizhi: "信息维护",
    wuliu: "物流查询",
    tuiguang: "推广中心",
    userAgreement: "用户协议",
    cangku: "仓库地址",
    shoujian: "收件人",
    dianhua: "电话",
    youbian: "邮编",
    dizhi1: "地址",
    xiadan: "快捷下单",
    yunshu: "运输方式",
    chooseYunshu: "选择运输方式",
    yaoqin: "邀请记录",
    zhuce: "注册日期",
    namse: "客户名称",
    jine: "发货金额",
    fanli: "可返利",
    tiyan: "立即提现",
    fanxianjilu: "返利记录",
    ketixian: "可提现金额",
  },
  EN: {
    //英文翻译
    CHONG: "Recharge",
    code: "CustomerCode",
    coupon: "coupon",
    DQtime: "expires",
    yue: "month",
    zhe: "fracture",
    vip: "vip",
    dizhi: "Information",
    wuliu: "Logistics query",
    tuiguang: "extension",
    userAgreement: "user agreement",
    cangku: "Warehouse address",
    shoujian: "addressee",
    dianhua: "Telephone",
    dizhi1: "address",
    xiadan: "Quick order",
    youbian: "Zip code",
    yunshu: "type of shipping",
    chooseYunshu: "Select transportation mode",
    yaoqin: "Invitation record",
    zhuce: "Date of registration",
    namse: "name",
    jine: "Shipment amount",
    fanli: "Rebate",
    tiyan: "Withdrawal",
    fanxianjilu: "Rebate record",
    ketixian: "Withdrawable cash",
  },
};
export default info;
